import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TrimText } from '../../../common/TrimText';

const ExpandableText = ({ maxWidth = 300, text, type = "" }) => {
  const contentRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);

  const stripHtml = (html) => {
    if (!html) return "-";
    try {
      const temp = document.createElement("div");
      temp.innerHTML = html;
      return temp.textContent || temp.innerText || "-";
    } catch (error) {
      console.error('Error stripping HTML:', error);
      return String(html || "-");
    }
  };

  useEffect(() => {
    const el = contentRef.current;
    if (el) {
      setShowToggle((el.scrollHeight > el.clientHeight) || (el.scrollWidth > el.clientWidth));
    }
  }, [text]);

  return (
    <div style={{ maxWidth }} title={stripHtml(text)}>
      {type === "programme" ? (
        <>
          <div
            ref={contentRef}
            className={`expandable-text ${isExpanded ? 'expanded' : ''}`}
          >
            {text?.map((item, index) => (
              <div key={index} className="assigned-title-block-new">
                <div className="assigned-title-itm">
                  {/* <PermissionsGate scopes={["umedit"]} RenderError={() => <p>{row.linkedCourse}</p>}> */}
                  <Link title={item.course} className="as-text-blue curser" target="_blank" to={`/courseAdministration/Programmes/programme/open/${item.qualification}/details`}>
                    {TrimText(item.course, 35)}
                  </Link>
                  {/* </PermissionsGate> */}
                </div>
              </div>
            ))}
          </div>

          {showToggle && (
            <span onClick={() => setIsExpanded(!isExpanded)} className="text-primary download-submission-btn cursor-pointer">
              {isExpanded ? 'See Less' : 'See More'}
            </span>
          )}
        </>
      ) : (
        <>
          <div
            ref={contentRef}
            className={`expandable-text ${isExpanded ? 'expanded' : ''}`}
            dangerouslySetInnerHTML={{ __html: text }}
          />

          {showToggle && (
            <span onClick={() => setIsExpanded(!isExpanded)} className="text-primary download-submission-btn cursor-pointer">
              {isExpanded ? 'See Less' : 'See More'}
            </span>
          )}
        </>
      )}
    </div>
  );
};

export default ExpandableText;
